// Foreva Jewels — switch between family products (metal / carat swatches) without a full page load.
// Clicking a [data-family-swatch] link fetches the sibling product page and swaps in the product
// section that contains the swatch. If the sibling uses a different template (so the section isn't
// found), or anything fails, it falls back to a normal page load.
// Loaded on product pages from snippets/fj-body-end.liquid.
(function () {
  if (window.__fjFamilyAjax) return;
  window.__fjFamilyAjax = true;

  document.addEventListener('click', async function (e) {
    const swatch = e.target.closest('[data-family-swatch]');
    if (!swatch || e.metaKey || e.ctrlKey || e.shiftKey) return;

    const url = swatch.getAttribute('href');
    const section = swatch.closest('.shopify-section');
    if (!url || !section || !section.id) return;

    e.preventDefault();
    section.classList.add('is-loading');

    try {
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error('Fetch failed');

      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const newSection = doc.getElementById(section.id);
      if (!newSection) throw new Error('Product section not found');

      newSection.classList.add('is-loading');
      section.replaceWith(newSection);
      requestAnimationFrame(() => newSection.classList.remove('is-loading'));

      if (doc.title) document.title = doc.title;
      history.pushState({ fjFamily: true }, '', url);

      if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
      document.dispatchEvent(new CustomEvent('product:changed'));
    } catch (err) {
      console.error('Family AJAX error', err);
      window.location.href = url;
    }
  });

  window.addEventListener('popstate', () => window.location.reload());
})();
